import assetLocationsService from "../../../../services/assetService/assetLocationsService";
import { useQuery } from "@tanstack/react-query";
import { CACHE_KEY_ASSETLOCATIONS } from "../../../../utils/constants";
import { AssetLocationInterface } from "../../../../models/AssetModel/AssetLocation";

const useAssetLocations = (page: number, pageSize: number) =>
  useQuery<AssetLocationInterface[], Error>({
    queryKey: [
      CACHE_KEY_ASSETLOCATIONS,
      page > 0 ? page : null,
      pageSize > 0 ? pageSize : null,
    ],
    queryFn: () => assetLocationsService.GetAll(page, pageSize),
  });

export default useAssetLocations;
